import $ from "jquery";

import _ from "underscore";

import template from "../templates/virtual_line_form.jst";

import TargetAreaLocator from "shared/components/target_area_locator";
import EditableSelectInputView from "shared/controls/editable_select_input_view";

import { bindErrorsToFormField } from "shared/stickit_helpers";
import Select from "shared/select";

import Config from "legacy/config";

import View from "backdraft-app/src/view";

import "vendor/bootstrap";

export default class BaseVirtualLineForm extends View {
  completeTemplateConfig() {
    return _.extend({}, this.templateConfig, {
      displayIfExists(value) {
        return _.isEmpty(value) ? 'display: none' : '';
      }
    });
  }

  render() {
    this.$el.html(template({
      affiliateNameFromNetwork: Config.localization.affiliateNameFromNetwork.name,
      config: this.completeTemplateConfig(),
      errors: this.model.get("errors")
    }));
    this._renderAdvertiserCampaignSelect();
    this._renderAffiliateCampaignSelect(this.model.get("advertiser_campaign_id"));
    this._renderTargetAreaLocator();
    this._wireEvents();
    this.renderCommon();
    this._toggleFormAttributes();
    this.$el.icon();
    return this;
  }

  renderCommon() {
    this.$(".js-popover").popover({ container: ".virtual-line-form" });
    this._renderAdwordsAccountSelect(this.model.get('media_type'));
    this._renderMediaTypeSelect();
    this.stickit();
    Select.initAll(this.$el);
  }

  defaultAdwordsAccount(accounts) {
    if (accounts && accounts.length === 1) {
      this.config.defaultAdwordsAccount = accounts[0];
    }
  }

  _renderAdvertiserCampaignSelect() {
    if (this.model.isNew() && this.config.manageVirtualLines.displayCampaignSelector) {
      const advertiserCampaignSelect = new EditableSelectInputView({
        attr: "advertiser_campaign_id",
        itemsAttr: "advertiser_campaigns",
        textAttr: 'advertiser_campaign_name',
        placeholder: 'Select campaign',
        width: 300,
        model: this.model,
        href: this.config.campaignListUrl
      });
      this.child("advertiser-campaign-select") && this.child("advertiser-campaign-select").close();
      this.child("advertiser-campaign-select", advertiserCampaignSelect);
      this.$("[data-mount=advertiser-campaign-area]").append(advertiserCampaignSelect.render().$el);
    }
  }

  _renderAffiliateCampaignSelect(advertiserCampaignId) {
    if (advertiserCampaignId && this.config.integrationLevel === "Network") {
      $.ajax(`${this.config.affiliateCampaignListUrl}&advertiser_campaign_id=${advertiserCampaignId}`, {
        success: data => { this._onSuccessfulAffiliateCampaignRequest(data, advertiserCampaignId); }
      });
    } else {
      this.$('[data-affiliate-campaign-selector-row="true"]').hide();
    }
  }

  _renderAdwordsAccountSelect(value, options) {
    if (this.config.manageVirtualLines.showAdwords || (this.config.googleCallExtensionMediaType && value === this.config.googleCallExtensionMediaType)) {
      this._showAdwordsAccountSelect();
    } else {
      this._hideAdwordsAccountSelect(options);
    }
  }

  _renderMediaTypeSelect() {
    if (this.config.manageVirtualLines.requireMediaType) {
      this._showMediaTypeSelect();
    } else {
      this.$("[data-mount=media_type-area]").hide();
    }
  }

  _renderTargetAreaLocator() {
    const targetAreaLocator = new TargetAreaLocator({});
    this.child("target-area-locator") && this.child("target-area-locator").close();
    this.child("target-area-locator", targetAreaLocator);

    this.$("[data-mount='form-target-area-locator']").html(this.child("target-area-locator").render().$el);
    targetAreaLocator.setRadiusInputDisabledProp(!this.model.get("number_pool_radius_checked"));
  }

  _onSuccessfulAffiliateCampaignRequest({ total_results: totalResults }, advertiserCampaignId) {
    if (totalResults > 0) {
      const affiliateCampaignSelect = new EditableSelectInputView({
        attr: "affiliate_campaign_id",
        itemsAttr: 'affiliate_campaigns',
        textAttr: 'affiliate_campaign_name',
        attributes: { "data-affiliate-campaign-id": true },
        placeholder: 'Select campaign (optional)',
        width: 300,
        model: this.model,
        href: (`${this.config.affiliateCampaignListUrl}&advertiser_campaign_id=${advertiserCampaignId}`)
      });

      this.$(".affiliate-campaign-area").html(affiliateCampaignSelect.render().$el);
      this.$('[data-affiliate-campaign-selector-row="true"]').show();
    } else {
      this.model.affiliate_campaign_id = 0;
      this.$('[data-affiliate-campaign-selector-row="true"]').hide();
    }
  }

  _showAdwordsAccountSelect() {
    const defaultSelectOptions = {
      attr: "adwords_account_id",
      attributes: { "data-adwords-account-id": true },
      itemsAttr: "adwords_accounts",
      textAttr: 'text',
      placeholder: 'Select a Google Ads account',
      width: 300,
      model: this.model,
      href: this.config.accountsListUrl
    };

    // set up the default to pre-populate select2
    if (this.config.defaultAdwordsAccount && !this.model.get('adwords_account_id')) {
      this.model.set('adwords_account_id', this.config.defaultAdwordsAccount.id);
      this.model.set('adwords_account_id_label', this.config.defaultAdwordsAccount.text);
    }

    const adwordsAccountSelect = new EditableSelectInputView(defaultSelectOptions);
    this.child("adwords-account-select") && this.child("adwords-account-select").close();
    this.child("adwords-account-select", adwordsAccountSelect);

    this.$("[data-mount=adwords-account-area]").html(this.child("adwords-account-select").render().$el);
    this.$("[data-group='adwords-account']").removeClass("ui-hidden");
    this.$("[data-action='adwords-media-type-warning']").addClass("ui-hidden");
  }

  _hideAdwordsAccountSelect(options) {
    this.model.set('adwords_account_id', null);
    this.$("[data-group='adwords-account']").addClass("ui-hidden");
    if (options && options.showWarning) {
      this.$("[data-action='adwords-media-type-warning']").removeClass("ui-hidden");
    }
  }

  _showMediaTypeSelect() {
    const defaultSelectOptions = {
      attr: 'media_type',
      attributes: { "data-media_type": true },
      itemsAttr: "media_types",
      textAttr: 'text',
      placeholder: 'Select media type',
      width: 300,
      model: this.model,
      select2Options: {
        data: this.config.mediaTypes
      }
    };
    const mediaTypeSelect = new EditableSelectInputView(defaultSelectOptions);
    this.child("media-type-select") && this.child("media-type-select").close();
    this.child("media-type-select", mediaTypeSelect);
    this.$("[data-mount=media_type-area]").append(mediaTypeSelect.render().$el);
  }

  _wireEvents() {
    this.listenTo(this.model, "change:promo_type", (model, value) => {
      this._toggleFormAttributes();
    });

    this.listenTo(this.model, "change:media_type", (model, value) => {
      this._renderAdwordsAccountSelect(value, {
        showWarning: !model.isNew() && model.previous('media_type') === this.config.googleCallExtensionMediaType
      });
    });

    this.listenTo(this.model, "change:advertiser_campaign_id", (model, value) => {
      this.model.unset("affiliate_campaign_id");
      this._renderAffiliateCampaignSelect(value);
    });
  }

  _toggleFormAttributes() {
    const localFormIsVisible = (this.model.get('promo_type') === 'local');
    this.$('[data-action=local-number-support]').toggleClass('ui-hidden', !localFormIsVisible);
  }
}

_.extend(BaseVirtualLineForm.prototype, {
  bindings: {
    ":radio[name='promo_type_switch']":                    "promo_type",
    "[data-description]":                                  "description",
    "input#target-area-text-field":                        "number_pool_location",
    "input#radius-field-checked":                          "number_pool_radius_checked",
    "input#radius-distance":                               "number_pool_search_radius",
    "input[name='virtual_line[promo_number_looks_like]']": "promo_number_looks_like",

    "[data-mount=media_type] [data-mount=errors]":             bindErrorsToFormField("Media type", "media_type"),
    "[data-mount=description] [data-mount=errors]":            bindErrorsToFormField("Description", "description"),
    "[data-mount=advertiser_campaign_id] [data-mount=errors]": bindErrorsToFormField("This field", "advertiser_campaign_id"),
    "[data-mount=promo_type] [data-mount=errors]":             bindErrorsToFormField("Number type", "promo_type"),
    "[data-mount=promo_number_looks_like] [data-mount=errors]": bindErrorsToFormField("Looks like", "promo_number_looks_like"),
    "[data-mount=adwords_account_id] [data-mount=errors]":     bindErrorsToFormField("Adwords Account", "adwords_account_id")
  }
});
